import React from 'react';
import { Typography } from 'antd';
import './Header.css';

const { Title, Text } = Typography;

interface HeaderProps {
  title?: string;
  subtitle?: string;
}

const Header: React.FC<HeaderProps> = ({
  title = "Internship Opportunities",
  subtitle = "Apply to a wide range of roles and kickstart your career with top companies."
}) => {
  return (
    <div className="portal-header">
      <div className="header-content">
        <div className="header-main">
          <div className="header-text">
            <Title level={1} className="portal-title">
              {title}
            </Title>
            <Text className="portal-subtitle">
              {subtitle}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header; 